import { IDisplayByType } from 'utils/types';

export interface IChartOptionsConfig {
  contributions?: string;
  displayBy: IDisplayByType;
  level1?: string;
  level2?: string;
  level3?: string;
  revenueCheckbox: boolean;
  costCheckbox: boolean;
  costAsPercentageCheckbox: boolean;
  selectedCategory?: string;
}

export interface IProduct {
  contribution: string;
  fte: number;
  headcount: number;
  productId: number;
  productName: string;
  productRevenue: number;
  spend: number;
  totalItCost: number;
}

export interface IProductResponse {
  nonProductCost: number;
  nonProductTotalItCost: number;
  productsSpend: IProduct[];
}

export interface ISpendByProduct {
  applicationId: number;
  applicationName: string;
  contribution: string;
  fte: number;
  headcount: number;
  percentageOfAllAppSpend: number;
  percentageOfAllITSpend: number;
  spend: number;
}

export interface ISpendByProductResponse {
  applicationsSpendByProduct: ISpendByProduct[];
  nonApplicationsSpendByProduct: ISpendByProduct[];
}

export const CONTRIBUTION_UI_TO_API: { [key: string]: string } = {
  Personnel: 'Personnel',
  'Third party': 'ThirdParty',
};

export const CONTRIBUTION_API_TO_UI: { [key: string]: string } = {
  Personnel: 'Personnel',
  ThirdParty: 'Third party',
};

export interface IApplicationSpend {
  contribution: string;
  dim1: string;
  dim2: string;
  dimensionName: string;
  fte?: number;
  headcount: number;
  percentageOfAllAppSpend: number;
  percentageOfAllITSpend: number;
  spend: number;
}

export interface IChartLegend {
  title: string;
  items: string[];
}

export interface IChartData {
  categories: string[];
  series: any[];
  legend: IChartLegend;
  tableData: any[];
}
